import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="container-page">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Most Popular Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg">
            Browse our curated AllChinaBuy Spreadsheet categories. Every link is verified daily by our team of experienced buyers.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4" data-product-shop>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 cursor-pointer hover:border-primary-300 overflow-hidden transition-all duration-200"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - AllChinaBuy Spreadsheet category`}
                  title={`${cat.name} on AllChinaBuy Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col gap-1.5 p-4 md:p-5">
                <span className="text-xs md:text-sm font-semibold text-foreground-800 leading-tight">
                  {cat.name}
                </span>
                <span className="text-[10px] md:text-xs text-foreground-400 leading-snug hidden sm:block">
                  {cat.description}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}